riot.tag2('gb-content-zone', '<span>{zone.content}</span>', '', '', function(opts) {
});



/** WEBPACK FOOTER **
 ** ./src/tags/template/gb-content-zone.tag.html
 **/